import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateOffer as updateOfferApi } from "../../../../services/dashboard/apiOffers";
import toast from "react-hot-toast";

function useUpdateOffer() {
  const queryClient = useQueryClient();

  const {
    mutate: updateOffer,
    isPending: isUpdating,
    error,
  } = useMutation({
    mutationFn: updateOfferApi,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["offers"],
      });

      toast.success("تم تعديل العرض بنجاح");
    },

    onError: (error) => {
      toast.error(error.response.data.message);
    },
  });

  return { updateOffer, isUpdating, error };
}

export default useUpdateOffer;
